import React, { Component } from 'react';

import { Headline, Copy, CTA } from '../../theme';

class Homepage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            classList: ['container__fluid'],
            switch: true
        };
        this.sound = new Audio(require('../../../assets/img/intro/click-sound.wav'))
    }


    componentDidMount = () => {
        const classList = [...this.state.classList];
        classList.push('switch-only');

        setTimeout(() => {
            this.setState({ classList });
        }, 6000);

    }

    lightsOff = () => {
        this.setState(
            { switch: false },
            () => {
                this.sound.play();
                setTimeout(() => this.props.history.push('/intro'), 1000);
            }
        );
    }

    render() {
        return (
            <div id="Homepage" className={this.state.classList.join(' ')}>
                <div className="w__flex w__flex-column Align-center Justify-center">

                    <div className="w__flex w__flex-row w__flex-column__mobile Align-center w__switch">
                        <div className="cell">
                            <Headline normal alignLeft padding="9vw">
                                <h1 style={{ color: '#181818' }}>Economisesc,</h1>
                                <h1 style={{ color: '#181818' }}>Dar cum?</h1>
                            </Headline>
                        </div>
                        <div onClick={this.lightsOff} className="cell switch switch-cursor">
                            <img src={require(`../../../assets/img/intro/switch-${this.state.switch ? 'on' : 'off'}.png`)} alt="Intrerupator" />
                        </div>
                        <div className="cell">
                            <Copy small>
                                <span>Economiseste energie si bani,</span>
                                <span>schimband obiceiuri sau</span>
                                <span> electrocasnice vechi.</span>
                            </Copy>
                        </div>
                    </div>

                    <div className="w__flex w__flex-row logos">
                        <div className="cell">
                            <img src={require('../../../assets/img/logos/logo-arctic.png')} alt="Logo Arctic" />
                        </div>
                        <div className="cell">
                            <img src={require('../../../assets/img/logos/logo-green.png')} alt="Logo Green" />
                        </div>
                        <div className="cell">
                            <img src={require('../../../assets/img/logos/logo-enel.png')} alt="Logo Enel" />
                        </div>
                    </div>

                    <div className="cta-wrapper">
                        <div className="cell">
                            <CTA arrowUp >Apasa</CTA>
                        </div>
                    </div>

                    <div className="loading-bar__container">
                        <div className="loading-bar"></div>
                    </div>

                </div>
            </div>
        );
    }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/components/pages/Homepage/Homepage.jsx